<script>
export default {
    name: 'BaseVideo',
};
</script>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    value:        {
        type: Boolean,
    },
    link:         {
        type:     String,
        required: true,
    },
    previewLink:  {
        type: String,
    },
    customClass:  {
        type: [String, Array, Object],
    },
    previewClass: {
        type:    [String, Array, Object],
        default: 'h-44 rounded-sm',
    },
});

const emit = defineEmits({
    input: null,
    close: null,
});

const internalOpen = ref(false);

const model = computed({
    get() {
        return props.previewLink ? internalOpen.value : props.value;
    },
    set(value) {
        if (!props.previewLink) {
            return emit('input', value);
        }

        internalOpen.value = value;
    },
});

function closeModal() {
    if (!props.previewLink) {
        return emit('close');
    }

    internalOpen.value = false;
}
</script>

<template>
    <div>
        <div
            v-if="previewLink"
            class="relative overflow-hidden cursor-pointer aspect-video"
            :class="previewClass"
            @click="internalOpen = true"
        >
            <img
                class="w-full h-full object-cover"
                alt="Video preview"
                :src="previewLink"
            >

            <div class="group absolute inset-0 flex items-center justify-center transition-colors hover:bg-black/20">
                <base-icon class="text-white/80 group-hover:text-white/100 transition-colors" name="play" size="3x" />
            </div>
        </div>

        <base-modal
            v-model="model"
            size="large"
            :show-close="false"
            @close="closeModal"
        >
            <template #content>
                <iframe
                    allowfullscreen
                    class="w-full aspect-video"
                    allow="autoplay; encrypted-media"
                    frameborder="0"
                    :class="customClass"
                    :src="`${link}?rel=0&showinfo=0&autoplay=1`"
                />
            </template>
        </base-modal>
    </div>
</template>
